import React, { useEffect } from 'react';
import { Alert } from 'components/common';
import { useTemplate, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems, notificationType } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { WorkflowSchema } from 'schemas';
import WorkflowFormDumb from './WorkflowFormDumb';


const WorkflowCreateSmart = () => {
  const { parameters, filters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, postWorkflow } = useTemplate();

  const defaultValues = {
    name: '',
    description: '',
    project: filters.project?parseInt(filters.project):0,
    userProject: '',
    notifications: [],
    notificationType: notificationType[0].value,
    workflowDefinition: []
  };

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    const workflow = new WorkflowSchema();
    workflow.setValues(data);
    postWorkflow({
      body: { ...workflow.getValues() },
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.WORKFLOW_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      { projects && <WorkflowFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} /> }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(WorkflowCreateSmart));
